import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.SNS_USER = function (state, payload) {
  state.sns_user = payload
}
mutations.SNS_ACCOUNT = function (state, payload) {
  state.sns_account = payload
}
mutations.COLLAB_LIST = function (state, payload) {
  state.collab_list = payload
}

const state = {
  rows: [],
  row: null,
  twitterLoginPage: null,
  twitterLogin: null,
  twitterLoginDetail: null,
  sns_user: [],
  condition: {},
  sns_account: [],
  collab_list: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        sns_account: { api: 'M0101SNSAccountService.getSnsAccountList' },
        getSNSUser: { api: 'M0101SNSAccountService.getUserNameList' },
        getCollabList: { api: 'M0001UserService.getCollabList' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('SNS_ACCOUNT', data.sns_account.output)
        commit('SNS_USER', data.getSNSUser.output)
        commit('COLLAB_LIST', data.getCollabList.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0001User cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'M0001UserService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0001User add')
    commit('EDIT',
      {
        id: null
        // files: {},
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'M0001UserService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0001UserService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0001UserService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0001User download')
    return client.download({ data: { download: { api: 'M0001UserService.downloadData', input: condition } } })
  },

  // test Twitter login
  twitterLoginPage: ({ commit, state }, twitterLoginPage) => {
    console.debug('called M0103SNSTwitterService twitterLoginPage')
    return client.postData({ data: { getOauth: { api: 'M0104SNSTwitterService.loginPage', input: twitterLoginPage } } })
      .then((data) => {
        commit('TWITTER_LOGIN_PAGE', data.getOauth.output)
      })
  },
  twitterLogin: ({ commit, state }, twitterLogin) => {
    console.debug('called M0103SNSTwitterService twitterLogin')
    return client.postData({ data: { getOauthToken: { api: 'M0104SNSTwitterService.loginTwitter', input: twitterLogin } } })
      .then((data) => {
        commit('TWITTER_LOGIN', data.getOauthToken.output)
      })
  },
  saveTwitterLoginDetail: ({ commit, state }, input) => {
    console.debug('called M0103SNSTwitterService twitterLogin')
    return client.postData({ data: { saveTwitterLogin: { api: 'M0104SNSTwitterService.saveTwitterLoginDetail', input: input } } })
      .then((data) => {
        commit('SAVE_TWITTER_LOGIN', data.saveTwitterLogin.output)
      })
  },
  // test Twitter login END

  // M0002SNSLinkIndex functions
  getUserNameList: ({ commit, state }, condition) => {
    console.debug('called M0110SNSMetrics search')
    return client.postData({ data: { getSNSUser: { api: 'M0101SNSAccountService.getUserNameList', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.getSNSUser.output)) {
        }
        commit('SNS_USER', data.getSNSUser.output)
      })
  },
  saveSnsUser: ({ commit, state }, input) => {
    return client.postData({ data: { saveSnsAccount: { api: 'M0101SNSAccountService.saveSnsUser', input: input } } })
      .then((data) => {
        commit('SNS_ACCOUNT', data.saveSnsAccount.output)
      })
  },
  deleteSnsUser: ({ commit, state }, input) => {
    return client.postData({ data: { deleteSnsAccount: { api: 'M0101SNSAccountService.deleteSnsUser', input: input } } })
      .then((data) => {
        commit('SNS_ACCOUNT', data.deleteSnsAccount.output)
      })
  },
  doLoginSns: ({ commit, state }, input) => {
    return client.postData({ data: { doLoginSns: { api: 'M0101SNSAccountService.loginSns', input: input } } })
      .then((data) => {
        commit('SNS_ACCOUNT', data.doLoginSns.output)
      })
  },
  // M0002SNSLinkIndex functions END

  // M0002SNSLinkCollab functions
  removecollab: ({ commit, state }, input) => {
    return client.postData({ data: { removeCollab: { api: 'M0001UserService.removeCollab', input: input } } })
      .then((data) => {
        commit('COLLAB_LIST', data.removeCollab.output)
      })
  }
  // M0002SNSLinkCollab functions END
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
